import { taggedTemplateLiteral as _taggedTemplateLiteral, objectWithoutProperties as _objectWithoutProperties, extends as _extends, objectSpread2 as _objectSpread2 } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import propTypes from '../../../node_modules/prop-types/index.js';
import React, { useCallback } from 'react';
import classnames from '../../../node_modules/classnames/index.js';
import { styled, useFormControl } from '@mui/material';
import { useDropzone } from '../../../cinnamon-mui/node_modules/react-dropzone/dist/es/index.js';
import FilePickerButton from './FilePickerButton.js';
import FilePickerDropzone from './FilePickerDropzone.js';
import { createComponentSlot } from '../../../modules/styling/theme.js';

var _templateObject;

var _excluded = ["value", "onChange", "dropzone", "multiple", "disabled", "readOnly", "children", "buttonComponent", "buttonProps", "dropzoneComponent", "dropzoneProps", "className", "sx", "onDrop", "noClick", "noKeyboard", "noDrag"],
    _excluded2 = ["disabled"];
var componentRoot = createComponentSlot({
  name: "CinFilePicker",
  slot: "Root"
});

var FilePickerBase = function FilePickerBase(_ref) {
  var value = _ref.value,
      onChange = _ref.onChange,
      dropzone = _ref.dropzone,
      _ref$multiple = _ref.multiple,
      multiple = _ref$multiple === void 0 ? false : _ref$multiple,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      _ref$readOnly = _ref.readOnly,
      readOnly = _ref$readOnly === void 0 ? false : _ref$readOnly,
      children = _ref.children,
      _ref$buttonComponent = _ref.buttonComponent,
      ButtonComponent = _ref$buttonComponent === void 0 ? FilePickerButton : _ref$buttonComponent,
      buttonProps = _ref.buttonProps,
      _ref$dropzoneComponen = _ref.dropzoneComponent,
      DropzoneComponent = _ref$dropzoneComponen === void 0 ? FilePickerDropzone : _ref$dropzoneComponen,
      dropzoneProps = _ref.dropzoneProps,
      className = _ref.className;
      _ref.sx;
      var onDrop = _ref.onDrop,
      noClick = _ref.noClick;
      _ref.noKeyboard;
      var noDrag = _ref.noDrag,
      otherProps = _objectWithoutProperties(_ref, _excluded);

  var dropzoneDrop = useCallback(function (acceptedFiles, fileRejections, event) {
    if (onDrop) onDrop(acceptedFiles, fileRejections, event);
    if (!acceptedFiles || acceptedFiles.length === 0) return;
    var newValue = multiple ? acceptedFiles : acceptedFiles[0];
    if (onChange) onChange(newValue);
  }, [onChange, onDrop, multiple]);
  var dropzoneState = useDropzone(_objectSpread2(_objectSpread2({}, otherProps), {}, {
    multiple: multiple,
    disabled: disabled || readOnly,
    noClick: !dropzone || noClick,
    noKeyboard: !dropzone || noClick,
    noDrag: !dropzone || noDrag,
    onDrop: dropzoneDrop
  }));
  var renderState = {
    multiple: multiple,
    disabled: disabled,
    readOnly: readOnly,
    focused: dropzoneState.isFocused,
    dragActive: dropzoneState.isDragActive,
    dragAccepting: dropzoneState.isDragAccept,
    dragRejecting: dropzoneState.isDragReject,
    dialogActive: dropzoneState.isFileDialogActive,
    acceptedFiles: dropzoneState.acceptedFiles,
    fileRejections: dropzoneState.fileRejections
  };
  var onClear = useCallback(function () {
    return onChange && onChange(null);
  }, [onChange]);
  var renderEvents = {
    onOpenDialog: dropzoneState.open,
    onClear: onClear
  };
  var content = typeof children === "function" ? children(value, renderState, renderEvents) : children;
  return /*#__PURE__*/React.createElement("div", _extends({}, dropzoneState.getRootProps(), {
    className: classnames(componentRoot.className, className)
  }), /*#__PURE__*/React.createElement("input", dropzoneState.getInputProps()), dropzone ? /*#__PURE__*/React.createElement(DropzoneComponent, _extends({}, dropzoneProps, {
    pickerValue: value,
    pickerState: renderState,
    pickerEvents: renderEvents
  }), content) : /*#__PURE__*/React.createElement(ButtonComponent, _extends({}, buttonProps, {
    pickerValue: value,
    pickerState: renderState,
    pickerEvents: renderEvents
  }), content));
};

FilePickerBase.propTypes = {
  value: propTypes.any,
  onChange: propTypes.func,
  dropzone: propTypes.bool,
  multiple: propTypes.bool,
  disabled: propTypes.bool,
  readOnly: propTypes.bool,
  children: propTypes.oneOfType([propTypes.node, propTypes.func]),
  buttonComponent: propTypes.elementType,
  buttonProps: propTypes.any,
  dropzoneComponent: propTypes.elementType,
  dropzoneProps: propTypes.any,
  className: propTypes.string,
  sx: propTypes.any
};
var StyledFilePicker = styled(FilePickerBase, componentRoot.styledOptions)(_templateObject || (_templateObject = _taggedTemplateLiteral([""])));
/**
 * An input for choosing a file with optional drag-and-drop
 */

var FilePicker = function FilePicker(_ref2) {
  var disabled = _ref2.disabled,
      props = _objectWithoutProperties(_ref2, _excluded2);

  var formControl = useFormControl();
  return /*#__PURE__*/React.createElement(StyledFilePicker, _extends({}, props, {
    disabled: disabled !== null && disabled !== void 0 ? disabled : formControl === null || formControl === void 0 ? void 0 : formControl.disabled
  }));
};

var FilePicker$1 = FilePicker; // --- legacy compatibility for deprecated imports ---

/**
 * @deprecated import these components directly
 */

var InputContent = {
  FilePickerButton: FilePickerButton,
  FilePickerDropzone: FilePickerDropzone
};

export { InputContent, FilePicker$1 as default };
